import { useContext, useEffect } from "react";
import AboutContent from "../components/AboutContent";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import { useNavigate } from "react-router-dom";
import { CarbonContext } from "../CarbonContext";

const About = () => {
  const { token } = useContext(CarbonContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (!token.access_token) {
      navigate("/");
    }
  }, [token, navigate]);
  return (
    <>
      <Navbar />
      <AboutContent />
      <Footer />
    </>
  );
};

export default About;
